import { render, staticRenderFns } from "./DeliverySucessoPixView.vue?vue&type=template&id=751c6b26&scoped=true&"
import script from "./DeliverySucessoPixView.vue?vue&type=script&lang=js&"
export * from "./DeliverySucessoPixView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c6b26",
  null
  
)

export default component.exports